import { render, staticRenderFns } from "./Mocktest.vue?vue&type=template&id=3491a1ae&"
import script from "./Mocktest.vue?vue&type=script&lang=js&"
export * from "./Mocktest.vue?vue&type=script&lang=js&"
import style0 from "./Mocktest.vue?vue&type=style&index=0&id=3491a1ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports